import { ButtonHTMLAttributes } from 'react';

import { Tooltip } from 'libs/ui';
import { ColorType } from 'libs/ui/theme';

import { ActionStyled } from './Action.styles';

interface ActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tooltip: string;
  borderColor?: ColorType | string;
}

export const Action = ({ tooltip, ...props }: ActionProps) => (
  <Tooltip title={tooltip}>
    <ActionStyled {...props} />
  </Tooltip>
);
